import {useEffect, useState} from "react";
import Cookies from "js-cookie";

export const CurrentUser = () => {
    try {
        const userDetaile = Cookies.get("ut");
        // if (userDetaile == null) {
        //     //window.history.location.href= "/navtomain"
        //     window.location.assign("/navtomain");
        //
        //     return null
        // }
        if (userDetaile && userDetaile != null) {
            const root = JSON.parse(atob(userDetaile ?? ""));
            const datas = {
                user: {
                    FullName: JSON.parse(root.user).fullName,
                    UserName: JSON.parse(root.user)?.userName,
                     id: JSON.parse(root.user).id,
                },
                Role: JSON.parse(root.roles)[0]
            }
            
            return datas;
        }
    } catch (e) {

        window.location.assign("/login");
        return;
    }

    return null;
};
